import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfessionalContactCard = ({ professional }) => {
  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.15)' }}>
      <h2 className="text-lg font-bold text-white mb-5 flex items-center gap-2">
        <Icon name="Contact" size={20} color="#00D4FF" />
        Professional Contact
      </h2>

      <div className="space-y-3 mb-5">
        <a
          href={`tel:${professional?.phone}`}
          className="flex items-center gap-4 p-4 rounded-xl transition-all duration-200 group"
          style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.15)' }}
        >
          <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(0,212,255,0.15)' }}>
            <Icon name="Phone" size={18} color="#00D4FF" />
          </div>
          <div>
            <p className="text-xs font-medium mb-0.5" style={{ color: '#6B9EC4' }}>Direct Phone</p>
            <p className="text-sm font-semibold text-white">{professional?.phone}</p>
          </div>
          <Icon name="ChevronRight" size={16} color="#6B9EC4" className="ml-auto" />
        </a>

        <a
          href={`mailto:${professional?.email}`}
          className="flex items-center gap-4 p-4 rounded-xl transition-all duration-200"
          style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.15)' }}
        >
          <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(0,212,255,0.15)' }}>
            <Icon name="Mail" size={18} color="#00D4FF" />
          </div>
          <div>
            <p className="text-xs font-medium mb-0.5" style={{ color: '#6B9EC4' }}>Email Address</p>
            <p className="text-sm font-semibold text-white">{professional?.email}</p>
          </div>
          <Icon name="ChevronRight" size={16} color="#6B9EC4" className="ml-auto" />
        </a>

        <div className="flex items-center gap-4 p-4 rounded-xl" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.15)' }}>
          <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(0,212,255,0.15)' }}>
            <Icon name="Clock" size={18} color="#00D4FF" />
          </div>
          <div>
            <p className="text-xs font-medium mb-0.5" style={{ color: '#6B9EC4' }}>Response Time</p>
            <p className="text-sm font-semibold text-white">{professional?.responseTime}</p>
          </div>
        </div>
      </div>

      {/* Policies */}
      <div className="rounded-xl p-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <p className="text-xs font-bold text-white mb-3">Policies</p>
        <div className="space-y-2">
          <div className="flex items-start gap-2">
            <Icon name="RefreshCw" size={13} color="#6B9EC4" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs" style={{ color: '#6B9EC4' }}><span className="text-white font-medium">Rescheduling:</span> Free rescheduling up to 24 hours before the consultation</p>
          </div>
          <div className="flex items-start gap-2">
            <Icon name="XCircle" size={13} color="#6B9EC4" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs" style={{ color: '#6B9EC4' }}><span className="text-white font-medium">Cancellation:</span> Cancel anytime before confirmation with no charge</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalContactCard;
